import {TheRave} from "../../TheRave";
import {WinPresentationController} from "../WinPresentationController";
import {IEnhancerReel} from "../../server/data/ITheRaveData";

export class ReplaceSPSymbols extends WinPresentationController {

    constructor() {
        super("ReplaceSPSymbols", true);
    }

    protected hasWin(): boolean {
        return TheRave.model.parsedGameData.scatterEnhancers.length > 0;
    }

    protected async createWinAnimation(): Promise<void> {
        TheRave.model.parsedGameData.scatterEnhancers.forEach((enhancer: IEnhancerReel) => {
            TheRave.reels[enhancer.reelId].replaceSymbol(enhancer.symbolId + 1, enhancer.symName);
            TheRave.reels[enhancer.reelId].getSymbol(enhancer.symbolId + 1).visible = true;
            TheRave.enhancerReels[enhancer.reelId].reelView.hide();
            TheRave.enhancerReels[enhancer.reelId].replaceSymbol("X");

        });
        Promise.resolve();
    }

    public skip(): void {
        TheRave.model.parsedGameData.scatterEnhancers.forEach((enhancer: IEnhancerReel) => {
            if(!TheRave.enhancerReels[enhancer.reelId].reelView.isLocked){
                TheRave.reels[enhancer.reelId].replaceSymbol(enhancer.symbolId + 1, enhancer.symName);
                TheRave.reels[enhancer.reelId].getSymbol(enhancer.symbolId + 1).visible = true;
                TheRave.enhancerReels[enhancer.reelId].reelView.hide();
                TheRave.enhancerReels[enhancer.reelId].replaceSymbol("X");
            }
        });
    }
}